export * from './Filters';
export * from './Page';
export * from './Product';
export * from './Search';
export * from './Sorting';

export const meilisearchPagesIndex = process.env.REACT_APP_MEILISEARCH_PAGES_INDEX || '';
export const meilisearchVariantsIndex = process.env.REACT_APP_MEILISEARCH_VARIANTS_INDEX || '';

export enum MeilisearchAttribute {
    type = 'type',
    id = 'id',
    code = 'code',
    categories = 'categories',
    isNew = 'is_new',
    isSale = 'is_sale',
    ranking = 'ranking',
    stock = 'stock',
    inStock = 'in_stock',
    sku = 'attributes.Productnummer',
    width = 'attributes.Breedte',
    height = 'attributes.Hoogte',
    depth = 'attributes.Diepte',
    weight = 'attributes.Gewicht',
    brand = 'attributes.Merk',
    color = 'attributes.Kleur',
    deliveryMin = 'attributes.DeliveryMin',
    deliveryMax = 'attributes.DeliveryMax',
    material = 'attributes.Materiaal',
    sizing = 'attributes.XS-XXL',
    new = 'attributes.Nieuw',
    isNewAttribute = 'attributes.isNew',
    price = 'price.price',
    priceDiscount = 'price.discount_difference',
    lists = 'lists.name',
}
